require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-basic-css-use-hex-code-for-specific-colors.json") })
        }
      }, "path---responsive-web-design-basic-css-use-hex-code-for-specific-colors");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-basic-css-use-hex-code-for-specific-colors!./.cache/json/responsive-web-design-basic-css-use-hex-code-for-specific-colors.json
// module id = 2617
// module chunks = 231608221292675